import * as type from '../types/bronze_test';
import actionCreatorFactory from 'typescript-fsa';
var actionCreator = actionCreatorFactory();
export var requestBronzeCheck = actionCreator(type.REQUEST_BRONZE_CHECK);
export var successBronzeCheck = actionCreator(type.SUCCESS_BRONZE_CHECK);
export var failureBronzeCheck = actionCreator(type.FAILURE_BRONZE_CHECK);
export var requestBronzeEntry = actionCreator(type.REQUEST_BRONZE_ENTRY);
export var successBronzeEntry = actionCreator(type.SUCCESS_BRONZE_ENTRY);
export var failureBronzeEntry = actionCreator(type.FAILURE_BRONZE_ENTRY);
export var requestBronzePayment = actionCreator(type.REQUEST_BRONZE_PAYMENT);
export var successBronzePayment = actionCreator(type.SUCCESS_BRONZE_PAYMENT);
export var failureBronzePayment = actionCreator(type.FAILURE_BRONZE_PAYMENT);